<template>
  <div class="min-h-screen font-sans antialiased relative">
    <div class="relative">
      <div class="cover-gradient-2 sm:cover-gradient"></div>
      <BaseNavbar />
      <main class="text-neutral-800">
        <div class="min-h-screen bg-gray-100">
          <div class="max-w-7xl mx-auto">
            <div class="flex flex-col md:flex-row min-h-[calc(100vh-10px)]">
              <!-- Sidebar -->
              <UserPortalSidebar />
              <!-- Main content -->
              <div class="flex-1 p-4 md:p-4 md:pt-6 overflow-auto">
                <slot />
              </div>
            </div>
          </div>
        </div>
      </main>
      <BaseFooter2 />
    </div>
    <GlobalCookieConsent />
    <LazyGlobalPhoneActionOverlay v-if="phoneMenuOpen || phoneHistoryOpen" />
    <LazyGlobalPublicCallOverlay v-if="publicCallOpen" />
  </div>
</template>

<script>
export default { name: 'UserPortalLayout' }
</script>
<script setup>
const { menuOpen: phoneMenuOpen, historyOpen: phoneHistoryOpen } = usePhoneActions()
const { open: publicCallOpen } = usePublicCallActions()
</script>
<style>@import "~/assets/css/default.css"; @import "~/assets/css/main.css";</style>
<style lang="scss">@import "~/assets/css/main.scss";</style>
